<mat-form-field class="mat_chip_form">
  <h1 mat-dialog-title>Filter</h1>
  <div id="popup_filter_dialog" mat-dialog-content>
    <p style="margin: 10px">Bitte wählen</p>
    <mat-chip-list #matChipList [multiple]="true" aria-label="Filter selection">
      <mat-chip *ngFor="let option of bundeslandFilterService.filter" class="mat_chip"
                [selectable]="true"
                (click)="selectOption(option)"
                [selected]="option.isSelected">{{option.name}}</mat-chip>
    </mat-chip-list>
    <div mat-dialog-actions>
      <button mat-button (click)="close()">Abbrechen</button>
      <button mat-button (click)="setFilter()">OK</button>
    </div>
  </div>
</mat-form-field>

